import { useState, useCallback } from 'react'
import { Modal, Button, Alert } from "react-bootstrap"
import Form from 'react-bootstrap/Form';
import Confirm from '../../../../Components/Modals/Confirm';
import { SaveRevisionGarantiaDetalle } from '../../../../api/Api';
import { useGetUser } from "../../../../Hooks/CustomHooks";
import { GARANTIA_TIPO } from '../../../Utils/Constants';

export default function CheckCobranzaModal({ showModal,
    setShowModal,
    idDetalleGarantia,
    tipoGarantia,
    onSuccess,
    //validationTitle, 
    validationList,
    isAfterSave }) {
    console.info("<========== COBRANZA")
    console.info(tipoGarantia, "<========= tipoGarantia")
    const user = useGetUser()
    const [checkBoxAll, setCheckBoxAll] = useState(false);
    const [checkboxes, setCheckboxes] = useState(tipoGarantia === GARANTIA_TIPO.GAR1_CARTA_FIANZA
        ? { "238BE23A-B18E-49A9-B4F8-222B3123603F": false } : {
            "44552E78-3B45-4DEA-997E-4110D2FBD509": false,
            "F53248B9-EE7F-48D9-8D11-4F4F49B46ED8": false
        });

    const checksTesoreriaGar11 = tipoGarantia === GARANTIA_TIPO.GAR1_CARTA_FIANZA
        ? { "238BE23A-B18E-49A9-B4F8-222B3123603F": "Error en importe final" }
        : {
            "44552E78-3B45-4DEA-997E-4110D2FBD509": "Error en importe final",
            "F53248B9-EE7F-48D9-8D11-4F4F49B46ED8": "No ingresó abono"
        };

    const [showModalConfirm, setShowModalConfirm] = useState(false);

    const handleCheckboxChange = event => {
        setCheckBoxAll(false);
        console.info(event);

        const { name, checked } = event.target;
        console.info(event.target.name, "event.target.name");
        console.info(event.target.checked, "event.target.checked");
        setCheckboxes(prevState => ({
            ...prevState,
            [name]: checked
        }));
    };
    const handleCheckAll = event => {
        const { checked } = event.target;
        //Solo si marca la opcion
        setCheckBoxAll(checked);
        if (checked) {
            if (tipoGarantia === GARANTIA_TIPO.GAR1_CARTA_FIANZA) {
                setCheckboxes(prevState => ({
                    ...prevState,
                    ["238BE23A-B18E-49A9-B4F8-222B3123603F"]: !checked
                }));
            } else {
                setCheckboxes(prevState => ({
                    ...prevState,
                    ["44552E78-3B45-4DEA-997E-4110D2FBD509"]: !checked,
                    ["F53248B9-EE7F-48D9-8D11-4F4F49B46ED8"]: !checked
                }));
            }
        }
    };


    const handleClick = () => {
        // enviar `data` al servicio
        //console.log(data);
        //Oculta el Modal de Revision
        setShowModal(false);
        //Muestra el modal de Confirmacion
        setShowModalConfirm(true);
    };

    const saveRevision = useCallback(
        (idDetalleGarantia, revisiones, observaciones, rolRevisor, usuariorevisor) => {

            console.info(idDetalleGarantia, "idDetalleGarantia");
            console.info(revisiones, "revisionesssssss")
            SaveRevisionGarantiaDetalle(idDetalleGarantia, revisiones, observaciones, rolRevisor, usuariorevisor).then((response) => {
                onSuccess && onSuccess();
                setShowModal(false);
                console.info("Ok!!!!!!")
            })
        }, [idDetalleGarantia]
    )


    // Cierre del Modal
    const onCloseModalConfirm = () => {
        setShowModal(true);
    }

    //Confirmacion del Modal
    const onConfirmModalConfirm = () => {
        const revisiones = Object.entries(checkboxes).map(([key, value]) => ({ [key]: value }));
        const revisionesObject = revisiones.reduce((obj, item) => {
            const key = Object.keys(item)[0];
            obj[key] = item[key];
            return obj;
        }, {});

        var item = `<form class=''>`
        Object.entries(checkboxes).forEach(([key, value]) => {
            item = item + `<div class='py-3 form-check'>`
            item = item + `<input type='checkbox' class='form-check-input' ${value ? "checked='true'" : ""} />`
            item = item + `<label title='' class='form-check-label'>${checksTesoreriaGar11[key]}</label>`
            item = item + `</div>`
            //item = item + `<li><i class="fi fi-rr-checkbox"></i> ${checksTesoreriaGar11[key]} </li>`;
        })
        var newItem = item + `</form>`
        console.info(newItem);
        saveRevision(idDetalleGarantia, revisionesObject, newItem, user.role.id, user.email);
    }

    const isNoneCheckSelected = () => {
        return Object.values(checkboxes).every(checked => !checked) && !checkBoxAll;
    }

    return (
        <>
            <Modal show={showModal} onHide={() => setShowModal(false)} backdrop="static" keyboard={false} aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header >
                    <Modal.Title>Revisión de Garantía para aprobación</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert key='info' variant='info'>
                        <b>INFORMACION</b>: Revise cuidadosamente los datos registrados en la Garantía y seleccione las opciones que usted crea conveniente antes de <b><u>guardar</u></b> la revisión.
                    </Alert>
                    {isNoneCheckSelected() &&
                        <Alert key='warning' variant='warning'>
                            <b>ADVERTENCIA</b>: Marque al menos una de las opciones presentadas para poder <b><u>guardar</u></b> la revisión.
                        </Alert>
                    }

                    <Form>
                        <Form.Check

                            type="checkbox"
                            label='Toda la informacion es correcta.'
                            name='check_all'
                            checked={checkBoxAll}
                            onChange={handleCheckAll}
                            className='py-3'
                        />
                        {Object.entries(checksTesoreriaGar11).map(([key, value]) => (
                            <Form.Check
                                key={key}
                                type="checkbox"
                                label={value}
                                name={key}
                                checked={checkboxes[key]}
                                onChange={handleCheckboxChange}
                                className='py-3'
                            />
                        ))}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secundary"
                        onClick={() => setShowModal(false)}
                    >Cerrar</Button>
                    <Button
                        variant="primary"
                        onClick={handleClick}
                        disabled={isNoneCheckSelected()}
                    >Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Confirm
                showModal={showModalConfirm}
                setShowModal={setShowModalConfirm}
                onClose={onCloseModalConfirm}
                onConfirm={onConfirmModalConfirm}
                message={'Seguro que desea <b><u>confirmar</u></b> la revision de la Garantía?'}
            />

        </>
    )
}